// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BNLV","questions":"styles_questions__uDAzx","footer":"styles_footer__3RFq6"};